// eslint-disable-next-line func-names
(function() {
  window.VALIDETTA_LANGUAGE = {
    required: 'Bu alanı doldurmanız gerekli.',
    email: 'Eposta adresiniz geçersiz görünüyor.',
    number: 'Bu alana sadece rakam girişi yapabilirsiniz.',
    maxLength: 'En fazla {count} karakter girebilirsiniz!',
    minLength: 'En az {count} karakter girmelisiniz!',
    maxChecked: 'En fazla {count} seçim yapabilirsiniz.',
    minChecked: 'En az {count} seçim yapmalısınız.',
    maxSelected: 'En fazla {count} seçim yapabilirsiniz.',
    minSelected: 'En az {count} seçim yapmalısınız.',
    notEqual: 'Alanlar birbiriyle oyuşmuyor',
    different: 'Alanlar birbirlerinden farklı olmalı.',
    creditCard: 'Kredi kartı numarası geçersiz.',
  };
})();
